import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useMemo } from 'react';
import cn from 'classnames';
import { colord } from 'colord';
import { useStateInRef } from '../../utils/useStateInRef';
import styles from './Theme.module.scss';
function getFullTheme(theme) {
    const fullTheme = _object_spread({}, theme);
    const textStandard = theme['--text-standard'];
    if (textStandard) {
        fullTheme['--text-standard-light'] = colord(textStandard).lighten(0.1).toHex();
    }
    const buttonPrimary = theme['--button-primary'];
    if (buttonPrimary) {
        fullTheme['--button-primary-dark'] = colord(buttonPrimary).darken(0.1).toHex();
        fullTheme['--button-primary-light'] = colord(buttonPrimary).lighten(0.1).toHex();
    }
    const buttonDisabled = theme['--button-disabled'];
    if (buttonDisabled) {
        fullTheme['--button-disabled-dark'] = colord(buttonDisabled).darken(0.1).toHex();
    }
    return fullTheme;
}
const ThemeContext = /*#__PURE__*/ createContext({});
export const useTheme = ()=>useContext(ThemeContext);
export function ScopedThemeProvider(props) {
    const { theme, children, className, maxHeight, maxWidth, testId, style } = props;
    const fullTheme = useMemo(()=>getFullTheme(theme), [
        theme
    ]);
    return /*#__PURE__*/ _jsx(ThemeContext.Provider, {
        value: fullTheme,
        children: /*#__PURE__*/ _jsx("div", {
            className: cn(className, {
                [styles.maxHeight]: maxHeight,
                [styles.maxWidth]: maxWidth
            }),
            style: _object_spread({}, style, fullTheme),
            "data-testid": testId,
            children: children
        })
    });
}
export function RootThemeProvider(props) {
    const { theme, children } = props;
    const getTheme = useStateInRef(theme);
    useEffect(()=>{
        const root = document.documentElement;
        Object.entries(getFullTheme(getTheme())).forEach((param)=>{
            let [key, value] = param;
            root.style.setProperty(key, value);
        });
    }, []);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
